import { Badge } from "@/components/ui/badge/badge";
import { cn } from "@/shared/lib/utils";

export interface FreshnessBadgeProps {
  updatedAt?: Date | null;
  /** Umbral en ms para considerar datos stale (default 15 min ≈ 3 ciclos de 5 min) */
  staleMs?: number;
  className?: string;
}

const DEFAULT_STALE_MS = 15 * 60 * 1000;

/**
 * Badge de frescura: "datos actualizados" vs "datos stale" (cron caído).
 */
export function FreshnessBadge({
  updatedAt,
  staleMs = DEFAULT_STALE_MS,
  className,
}: FreshnessBadgeProps): React.JSX.Element {
  if (!updatedAt) {
    return (
      <Badge variant="secondary" className={cn(className)}>
        Sin datos de la hora actual
      </Badge>
    );
  }

  const ageMs = Date.now() - updatedAt.getTime();
  const isStale = ageMs > staleMs;
  const minutes = Math.max(0, Math.floor(ageMs / 60000));

  return (
    <Badge
      variant={isStale ? "destructive" : "secondary"}
      className={cn(className)}
      title={updatedAt.toISOString()}
    >
      {isStale
        ? `Datos stale (~${minutes} min)`
        : `Datos actualizados hace ${minutes < 1 ? "<1" : minutes} min`}
    </Badge>
  );
}
